import { useEffect, useRef, useState } from 'react';
import Magnify from '@components/icons/Magnify';
import { getAPIToken } from '@security/User';
import BaseButton from '@components/pwa/buttons/BaseButton';
import LogoutButton from '@components/pwa/buttons/LogoutButton';
import Carousel from '@components/pwa/carousels/News';
import BaseList from '@components/pwa/lists/BaseList';
import IconList from '@components/pwa/lists/IconList';
import ImageList from '@components/pwa/lists/ImageList';
import News from '@pages/pwa/unit/News';
import User from '@components/icons/User';
import NewPendingUnit from '@pages/pwa/unit/NewPendingUnit';
import loudspeaker from '@assets/images/pwa/loudspeaker.png';
import tinyHouse from '@assets/images/pwa/tiny-house.png';
import classnames from 'classnames';

import style from './style.module.scss';
import { SwitchTransition, CSSTransition } from 'react-transition-group';
import Selection from '../Selection';
import Guide from '../Guide';
import Pending from '../Pending';

import news from '@assets/json/news.json';
import guides from '@assets/json/guides.json';

export default (props) => {
  const { unitsList, toggleScanner, unitFoundByScanner, refData } = props;

  const [isNewsOpened, setIsNewsOpened] = useState(false);
  const [isGuideOpened, setIsGuideOpened] = useState(false);
  const [isSelectionOpened, setIsSelectionOpened] = useState(false);
  const [isPendingOpened, setIsPendingOpened] = useState(false);
  const [isNewUnitOpened, setIsNewUnitOpened] = useState(false);
  const [currentUnit, setCurrentUnit] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [newUnitBarcode, setNewUnitBarcode] = useState(null);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const searchInput = useRef(null);

  useEffect(() => {
    if (unitFoundByScanner) {
      setCurrentUnit(unitFoundByScanner);
      setIsSelectionOpened(true);
    }

    return () => {
      setCurrentUnit(null);
    };
  }, []);

  function onChange() {
    const value = searchInput.current.value.replace(/\s/g, '');

    searchInput.current.value = value;
    const userInput = value.toUpperCase();

    if (userInput.length > 3) {
      const filteredSuggestions = unitsList.filter(
        (suggestion) =>
          suggestion.barcode.toUpperCase().indexOf(userInput) > -1,
      );
      setShowSuggestions(true);
      setFilteredSuggestions(filteredSuggestions);
    } else {
      setShowSuggestions(false);
      setFilteredSuggestions([]);
    }
  }

  function search() {
    const value = searchInput.current.value.toUpperCase();
    if (value) {
      // this.setState({ barcode: value });
      const data = unitsList.find(
        (unit) =>
          JSON.stringify(unit?.barcode?.trim().toUpperCase()) ===
          JSON.stringify(value.trim().toUpperCase()),
      );
      if (data) {
        if (navigator.vibrate) navigator.vibrate(200);
        setCurrentUnit(data);
        setIsSelectionOpened(true);
      } else {
        if (
          window.confirm(
            `Sorry, the ${value} barcode you are mentioning does not exist. But you may able to create it depending on your rights.\nAre you sure to create a new unit (${value})?`,
          )
        ) {
          setNewUnitBarcode(value);
          setIsNewUnitOpened(true);
        }
      }
    }
  }

  const pending = [
    {
      label: 'Units',
      picture: tinyHouse,
      storageName: 'requests',
    },
    {
      label: 'Reports',
      picture: loudspeaker,
      storageName: 'reports',
    },
  ];

  function selectedIndex(name, index = -1) {
    if (index >= 0) {
      switch (name) {
        case 'news':
          setIsNewsOpened(true);
          break;
        case 'guide':
          setIsGuideOpened(true);
          break;
        case 'pending':
          setIsPendingOpened(true);
        default:
          break;
      }
      setCurrentIndex(index);
    } else {
      setIsNewsOpened(false);
      setIsGuideOpened(false);
      setIsSelectionOpened(false);
      setIsNewUnitOpened(false);
      setIsPendingOpened(false);
    }
  }

  function handleSelection(barcode) {
    const value = barcode.toUpperCase();
    if (value) {
      const data = unitsList.find(
        (unit) =>
          JSON.stringify(unit?.barcode?.trim().toUpperCase()) ===
          JSON.stringify(value.trim()),
      );
      if (data) {
        if (navigator.vibrate) navigator.vibrate(200);
        setCurrentUnit(data);
      } else {
        if (
          window.confirm(
            `Sorry, the ${value} barcode you are mentioning does not exist. But you may be able to create it depending on your rights.\nAre you sure to create a new unit (${value})?`,
          )
        ) {
        }
      }
    }

    setIsSelectionOpened(true);
  }

  return (
    <div className={style['homepage']}>
      <header>
        <div className={style['content']}>
          <form
            className={style['homepage-form']}
            onSubmit={(e) => {
              e.preventDefault();
              search();
            }}
          >
            <label>
              <Magnify />
              <input
                type="text"
                placeholder="Enter your barcode"
                onChange={onChange}
                ref={searchInput}
              />
            </label>
          </form>
          <figure className={style['profile-picture']}>
            <img
              src={
                getAPIToken()
                  ? `${
                      process.env.REACT_APP_API_URL
                    }/api/get_avatar?access_token=${getAPIToken()}`
                  : 'data:image/gif;base64,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'
              }
              alt="avatar"
            />
          </figure>
        </div>

        {showSuggestions && !!filteredSuggestions.length && (
          <ul className={style['suggestions-list']}>
            {filteredSuggestions.map((suggestion, index) => (
              <li
                key={index}
                onClick={() => handleSelection(suggestion.barcode)}
              >
                {suggestion.barcode}
              </li>
            ))}
          </ul>
        )}
      </header>

      <Carousel items={news} selectedIndex={selectedIndex} />

      <div className={style['section-block']}>
        <span className={style['section-title']}>Let's check your status</span>
        {/* <IconList list={status} /> */}
        <div className={style['section-grid']}>
          <div className={style['status']}>
            <ul>
              <li>
                <span>Network</span>
                {props.isOffline ? '🔴' : '✅'}
              </li>
              <li>
                <span>Authenticated</span>
                {props.isAuthenticated ? '✅' : '🔴'}
              </li>
              <li className={style['status-state']}>
                {!props.isOffline && props.isAuthenticated ? '👍' : '⚠️'}
              </li>
            </ul>
          </div>
          <ImageList list={pending} selectedIndex={selectedIndex} />
        </div>
      </div>

      <div className={style['section-block']}>
        <span className={style['section-title']}>User Guide</span>
        <BaseList list={guides} selectedIndex={selectedIndex} />
      </div>

      <LogoutButton history={props.history} />

      <SwitchTransition mode="out-in">
        <CSSTransition key={isNewsOpened} classNames="slideRight" timeout={300}>
          <>
            {isNewsOpened && (
              <News
                news={news[currentIndex]}
                action={() => selectedIndex('news')}
              />
            )}
          </>
        </CSSTransition>
      </SwitchTransition>

      <SwitchTransition mode="out-in">
        <CSSTransition
          key={isGuideOpened}
          classNames="slideRight"
          timeout={300}
        >
          <>
            {isGuideOpened && (
              <Guide
                guide={guides[currentIndex]}
                action={() => selectedIndex('guide')}
              />
            )}
          </>
        </CSSTransition>
      </SwitchTransition>

      <SwitchTransition mode="out-in">
        <CSSTransition
          key={isPendingOpened}
          classNames="slideRight"
          timeout={300}
        >
          <>
            {isPendingOpened && (
              <Pending
                pending={pending[currentIndex]}
                action={() => selectedIndex('pending')}
              />
            )}
          </>
        </CSSTransition>
      </SwitchTransition>

      <SwitchTransition mode="out-in">
        <CSSTransition
          key={isSelectionOpened}
          classNames="slideRight"
          timeout={300}
        >
          <>
            {isSelectionOpened && (
              <Selection
                selectedIndex={selectedIndex}
                unit={currentUnit}
                isOffline={props.isOffline}
              />
            )}
          </>
        </CSSTransition>
      </SwitchTransition>

      <SwitchTransition mode="out-in">
        <CSSTransition
          key={isNewUnitOpened}
          classNames="slideRight"
          timeout={300}
        >
          <>
            {isNewUnitOpened && (
              <NewPendingUnit
                selectedIndex={selectedIndex}
                {...props}
                refData={refData}
                barcode={newUnitBarcode}
              />
            )}
          </>
        </CSSTransition>
      </SwitchTransition>
    </div>
  );
};
